const input = {
  name: 'trainingSignInput',
  path: '',
  meta: {
    title: '学员签到'
  },
  props: true,
  component: resolve => require(['../../../../../../pages/domain/sbs/training/sign/input'], resolve)
}

export default input
